import React, { useEffect, useState } from 'react'
import { SomosClient } from 'utils'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import Question from '../../Question'
import AlternativeList from '../../AlternativeList'

import styles from './QuestionsBucket.module.css'

const QuestionsBucketParagraph = ({ questionId }) => {
  const client = new SomosClient()
  const [question, setQuestions] = useState()

  useEffect(() => {
    client.getQuestion(questionId).then(response => {
      setQuestions(response.question)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setQuestions, questionId])

  if (!question) {
    return null
  }

  return (
    <div className={styles.questionBorder}>
      <div className={styles.title}>
        <Question
          size='small'
          title='Questão'
          text={question.text}
          alternatives={question.options}
        />

        {question?.options.length > 0 && <AlternativeList alternatives={question.options} />}
      </div>
    </div>
  )
}

QuestionsBucketParagraph.propTypes = {
  questionId: PropTypes.string.isRequired,
}

const fragments = {
  paragraph: gql`
    fragment QuestionsBucketParagraphFragment on ParagraphQuestionsBucket {
      questionId: fieldQuestionId
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { QuestionsBucketParagraph, fragments }
